import React, { useState } from "react";
import ToolbarHeader from "../../components/ToolbarHeader";
import WrapperWithTabs from "../../components/WrapperWithTabs";
import { tabBarOptions } from "./tabBarOptions";
import CustomButton from "../../components/CustomButton";

const AreaManagerRequests = () => {
  const [selectedTab, setSelectedTab] = useState(tabBarOptions[0]);
  return (
    <div className="dashboard-container">
      <ToolbarHeader
        title="Requests"
        showBack={false}
        containerClassName="mt-14"
      />
      <WrapperWithTabs
        tabBarOptions={tabBarOptions}
        wrapperClassName="mt-12"
        tabSelected={selectedTab}
        setTabSelected={setSelectedTab}
      />
    </div>
  );
};

export default AreaManagerRequests;
